import { usePageContent } from '../../hooks/usePageContent';
import useMeta from '../../hooks/useMeta';
import useTitle from '../../hooks/useTitle';
import SwiftSubscribeForm from '../../components/SwiftSubscribeForm';
import styles from './index.module.css';

const ExclusiveHeritagePlatesPage = () => {
  const { find, meta } = usePageContent('exclusive-heritage-plates');
  const seo = meta?.seo;
  useTitle(seo?.title || 'Heritage plates');
  useMeta(seo);
  const main = find('richText') || {};
  const form = find('subscribeForm') || {};

  return (
    <div id="content">
      <div className="page-header">
        <div className="container">
          <h1 className="page-header__title">{main.pageTitle || 'Heritage plates'}</h1>
        </div>
      </div>
      <div className="content-holder content-holder--indented">
        <div className={`rich-text ${styles.wrapper}`}>
          <div dangerouslySetInnerHTML={{ __html: main.richTextHtml || '' }} />
          {form.groupId && (
            <div className={styles.formWrap}>
              <SwiftSubscribeForm
                heading={form.heading}
                subtext={form.subtext}
                groupId={form.groupId}
                showPhone={!!form.showPhone}
                privacyUrl={form.privacyUrl}
                collectionNoticeUrl={form.collectionNoticeUrl}
                successMessage={form.successMessage}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExclusiveHeritagePlatesPage;
